import io from 'socket.io-client';

export default class MySocket {
  //Constructor to set the store reference, create socket io instance and initialize listeners.
  constructor(store) {
    this.store = store;
    this.socket = io('wss://api.spela.svenskaspel.se:443', {
        path: '/socket.io',
        upgrade: true,
        transport: ['websocket'],
        reconnection: true,
        reconnectionDelay: 500,
        maxReconnectionAttempts: Infinity,
    });

  }

  subscribe(product, draw) {

    let pathDraw = `/draw/1/${product}/draws/${draw}`
    let pathForecast = `/draw/1/${product}/draws/forecast/${draw}`
    let pathResult = `/draw/1/${product}/draws/${draw}/result`

    this.socket.on('connect', () => {
      this.store.commit('setConnected', true);
    });

    this.socket.on('disconnect', () => {
      this.store.commit('setConnected', false);
    });

    this.socket.on("update", message => {
      console.log("Recv msg");
      console.log(message);
      console.log(this.store.state.drawObject[draw]);

      console.log(message.path)

      if (message.path == pathResult) {
        console.log('Commiting result')
          this.store.commit('updateDrawObject', message.value)
      }

      if (message.path == pathForecast) {
        console.log('Commiting forecast')
          this.store.commit('updateDrawObject', message.value)
      }

      if (message.path == pathDraw) {
        //let regCloseTime = Date.parse(message.value.draw.regCloseTime);
        //let currentTime = new Date().getTime()

        let drawState = message.value.draw.drawState

        console.log('Commiting')
        this.store.commit('updateDrawObject', message.value)

        if (drawState == 'Closed') {
          let path = pathForecast;
          if (!this.store.state.subscription.includes(path)) {
            console.log('Subscribing to: ' + path)
            this.socket.emit("subscribe", {"url":path,"sendInitialUpdate":true});
            this.store.commit('registerSubscription', path);
          }
        }

        if (drawState == 'Finalized') {
          let path = message.path + '/result';
          if (!this.store.state.subscription.includes(path)) {
            console.log('Subscribing to: ' + path)
            this.socket.emit("subscribe", {"url":path,"sendInitialUpdate":true});
            this.store.commit('registerSubscription', path);
          }
        }

      }

    });

    // If not already subscribed -> subscribe
    if (!this.store.state.subscription.includes(pathDraw)) {
      this.socket.emit("subscribe", {"url":pathDraw,"sendInitialUpdate":true});
      this.store.commit('registerSubscription', pathDraw);
    }

  }

  unsubscribe() {
    //this.socket.emit("SubRemove", { subs: this.store.state.subscription });
  }
}
